import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  EmployeeCheckSource,
  EmployeeCheckSourceUpdateDto,
} from '@qaroni-app/employee/types/employee-check-source';
import { EmployeeCheckSourceApiObject } from '@qaroni-app/employee/types/employee-check-source-response';

import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';

@Injectable({
  providedIn: 'root',
})
export class EmployeeCheckSourceHttpService {
  private http = inject(HttpClient);

  public createChecksConfiguration$(
    companyID: number,
    employeeID: number,
    checkSource: EmployeeCheckSource
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/punchs/configurations`;
    return this.http.post<EmployeeCheckSourceApiObject>(url, checkSource);
  }

  public getCompanyChecksConfiguration$(companyID: number, employeeID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/punchs/configurations`;
    return this.http.get<EmployeeCheckSourceApiObject>(url);
  }

  public getEmployeeChecksConfiguration$(employeeID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeID}/punchs/configurations`;
    return this.http.get<EmployeeCheckSourceApiObject>(url);
  }

  public updateChecksConfiguration$(
    companyID: number,
    employeeID: number,
    checkSource: EmployeeCheckSourceUpdateDto
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/punchs/configurations`;
    return this.http.patch<EmployeeCheckSourceApiObject>(url, checkSource);
  }

  public deleteChecksConfiguration$(companyID: number, employeeID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/punchs/configurations`;
    return this.http.delete(url);
  }
}
